import React from 'react';

import BrightcovePlayer from '@components/video/brightcove_player/main';

export const ProcessingVideoPreview = (): JSX.Element => (
  <BrightcovePlayer
    attrs={{
      id: "advanced-video",
      className: "m-show-full-size-display processing",
      'data-private': true
    }}
    accountID={BFG.BRIGHTCOVE_ACCOUNT_ID}
    videoID="6045002940001"
    playerID="OV7Vi4enS"
  />
);
